import { ICropLine } from './cropData/cropLine/cropLine';
import { IField } from './masterData/field/field';
import { IPlantsPerHectare } from './masterData/plantsPerHectare/plantsPerHectare';
import { IProject } from './masterData/project/project';
import { ISeedTraySize } from './masterData/seedTraySize/seedTraySize';
import { ArrayHelper, IBaseModel, IOptionType } from '@zz2/zz2-ui';
import lodash from 'lodash';

interface ILabelSection {
    order : number;
    section : string;
}


export class OptionType {
    public static fromDataModel = function<T extends IBaseModel>(dataModel : T) : IOptionType {
        let labelSections : Array<ILabelSection> = [];

        if ('code' in dataModel && typeof dataModel.code === 'string' && dataModel.code !== '') {
            const labelSection : ILabelSection = {
                order: 1,
                section: dataModel.code.trim(),
            };

            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if ('name' in dataModel && typeof dataModel.name === 'string' && dataModel.name !== '') {
            const labelSection : ILabelSection = {
                order: 2,
                section: dataModel.name.trim(),
            };
            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if ('description' in dataModel
            && typeof dataModel.description === 'string'
            && dataModel.description !== ''
            && labelSections.length < 2) { // We don't want to add a description if the code and name have already been added.
            const labelSection : ILabelSection = {
                order: 3,
                section: dataModel.description.trim(),
            };
            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if (labelSections.length < 1) {
            return {
                label: 'Label Not Found',
                value: dataModel.id,
            };
        }

        if (labelSections.length > 1) {
            const orderedList = lodash.orderBy(labelSections, x => x.order, 'asc');
            return {
                label: `(${orderedList[0].section}) - ${orderedList[1].section}`,
                value: dataModel.id,
            };
        } else {
            return {
                label: labelSections[0].section,
                value: dataModel.id,
            };
        }
    }

    /*================================================================================================================
     *                                           Custom Option Type Map
     * ==============================================================================================================*/

    public static fromField = (field : IField) : IOptionType => {
        return {
            label: `(${field.department?.code}) ${field.name}`,
            value: field.id,
        };
    };

    public static fromProject = (project : IProject) : IOptionType => {
        return {
            label: `(${project.commodity?.name ?? ''}) - ${project.number}`,
            value: project.id,
        };
    };

    public static fromPlantsPerHectare = (plantsPerHectare : IPlantsPerHectare) : IOptionType => {
        return {
            label: plantsPerHectare.numberOfPlants.toString(),
            value: plantsPerHectare.id,
        };
    };

    public static fromSeedTraySize = (seedTraySize : ISeedTraySize) : IOptionType => {
        return {
            label: seedTraySize.size,
            value: seedTraySize.id,
        };
    };

    public static fromCropLine = (cropLine : ICropLine) : IOptionType => {
        return {
            label: `(${cropLine.cropId}) - CropLine`,
            value: cropLine.id,
        };
    };
}
